import { setUserWallet, setUserWalletList } from 'store/slices/wallet';
import { store } from 'store';
import RacingService from './RacingService';
// import RacingService from './RacingService';
// import LocalStorageService from './LocalStorageService';
import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getRacingData, setRaceCardChange, setRaceCardEventChage, setRaceStreamData } from 'store/slices/racecard';
import LocalStorageService from './LocalStorageService';

// Race-related toasts should only appear while the user is actually on a race
// screen for the matching event. On other pages we silently update redux state
// (so when they come back the data is current) but skip the toast noise.
const RACE_PATHS = ['/racing/', '/marbleracing/', '/luckysign/', '/luckysign36/', '/provider/', '/fixedracing/'];
const isOnRaceScreen = (raceKey?: string | number) => {
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    if (!RACE_PATHS.some((p) => path.includes(p))) return false;
    if (raceKey === undefined || raceKey === null || raceKey === '') return true;
    return path.includes(String(raceKey));
};
const raceToast = (message: string, raceKey?: string | number, options?: ToastOptions) => {
    if (!message) return;
    if (!isOnRaceScreen(raceKey)) return;
    toast(message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options
    });
};

export const updateModelAttributes = async (modelAttributes: any) => {

    if (modelAttributes.typename === 'wallet') {
        // debugger;
        const { wallet } = store.getState();
        let userWallet: any = { ...wallet.userWallet };
        const userWalletList = [...wallet.userWalletList];
        if (typeof userWallet === 'object' && userWallet !== null && 'walletId' in userWallet) {
            const { balance, walletId, winBalance, bonusBalance } = modelAttributes;
            if (walletId === userWallet.walletId) {
                userWallet.balance = balance ?? 0;
                userWallet.winBalance = winBalance ?? 0;
                userWallet.bonusBalance = bonusBalance ?? 0;
                store.dispatch(setUserWallet(userWallet));
            }
            const userWallets = userWalletList.map((w: any) => {
                if (w.walletId === walletId) {
                    return { ...w, balance };
                }
                return w;
            });
            store.dispatch(setUserWalletList(userWallets));
        }
    }
    if (modelAttributes.typename === 'racecardactions') {
        updateRaceCardEvents(modelAttributes);
    }
    if (modelAttributes.typename === 'racecardodds') {
        changeRaceOdds(modelAttributes);
    }
    if (modelAttributes.typename === 'stream') {
        // toast.success('Success message!');
        let streamData = {
            // ...raceinfo.raceStreamData,
            ...modelAttributes
        };
        if (streamData.provider === 'SIS') {
            const response = await getSISStreamURL(streamData.streamId);
            streamData.iframeFlag = 'N';
            if (response.error !== undefined && response.error) {
                streamData.message = response.error;
            } else {
                streamData.message = '';
                streamData.iframeFlag = 'Y';
                streamData.streamUrl = response.phenixEmbedUrl;
            }
        }
        // console.log(streamData);
        raceToast('Stream Added', streamData.raceCardId ?? streamData.programId);
        store.dispatch(setRaceStreamData(streamData));
    }
};

export const updateRaceCardEvents = (modelAttributes: any) => {
    // if (modelAttributes.action !== 'odds') console.log(modelAttributes.action);
    let notifyMessage = '';
    switch (modelAttributes.action) {
        case 'save':
            notifyMessage = `Race card for ${modelAttributes.venueCode} published`;
            fetchRaceCard(modelAttributes.action.raceCardId);
            break;
        case 'refresh':
            fetchRaceCard(modelAttributes.raceCardId);
            break;
        case 'startBet':
            notifyMessage = `Betting Started for ${modelAttributes.venueCode} race ${modelAttributes.races}`;
            changeRaceCard(modelAttributes, 'status', 'BST');
            break;
        case 'stopBet':
            notifyMessage = `Betting Stopped for ${modelAttributes.venueCode} race ${modelAttributes.races}`;
            changeRaceCard(modelAttributes, 'status', 'BSP');
            break;
        case 'resultSaved':
            notifyMessage = `Results Announced ${modelAttributes.venueCode} race ${modelAttributes.races}`;
            changeRaceCard(modelAttributes, 'statusView', 'STP');
            fetchRaceCard(modelAttributes.raceCardId);
            break;
        case 'resultPublished':
            notifyMessage = `Results Published ${modelAttributes.venueCode} race ${modelAttributes.races}`;
            fetchRaceCard(modelAttributes.raceCardId);
            break;
        case 'releaseDividend':
            notifyMessage = `Dividends Released For ${modelAttributes.venueCode} race ${modelAttributes.races}`;
            fetchRaceCard(modelAttributes.raceCardId);
            break;
        case 'withDraw_revert':
            changeRunner(modelAttributes);
            break;
        case 'withDraw':
            changeRunner(modelAttributes);
            break;
        default:
            //props.setRaceCardUpdated(props.raceCardUpdated+1);
            break;
    }
    raceToast(notifyMessage, modelAttributes.raceCardId);
};

const fetchRaceCard = (id: string) => {
    store.dispatch(getRacingData(id));
    store.dispatch(setRaceCardEventChage());
};

const getSISStreamURL = async (id: any) => {
    let result: any = await RacingService.getSISStreamUrl(id);
    return result.body.data;
};

const changeRaceOdds = async (data: any) => {
    let raceCardTemp: any = await RacingService.getLocalRaceData();
    raceCardTemp = JSON.parse(raceCardTemp);
    if (raceCardTemp === undefined || raceCardTemp === '' || raceCardTemp.details === undefined) {
        store.dispatch(getRacingData(data.raceCardId));
        return;
    }
    let racecard = raceCardTemp.details;
    const actualRunners = data.runners.reduce((previousObject: any, currentObject: any) => {
        return Object.assign(previousObject, {
            [currentObject.position]: currentObject
        });
    }, {});
    if (racecard[data.raceNumber - 1] !== undefined && racecard[data.raceNumber - 1]['runners'] !== undefined) {
        let runners = racecard[data.raceNumber - 1]['runners'];
        const resultRunners =
            runners.length > 0 &&
            runners?.map((item: any) => {
                if (actualRunners[item.position] !== undefined && actualRunners[item.position].odds !== undefined) {
                    item.odds = actualRunners[item.position].odds;
                    item.vendorOdds = actualRunners[item.position].vendorOdds;
                    return item;
                }
                return item;
            });
        raceCardTemp.details[data.raceNumber - 1]['runners'] = resultRunners;
        LocalStorageService.setItem('mp_raceinfo', JSON.stringify(raceCardTemp));
        store.dispatch(setRaceCardChange());
    }
};

const changeRaceCard = async (data: any, field: string, status: string) => {
    let raceCardTemp: any = await RacingService.getLocalRaceData();
    raceCardTemp = JSON.parse(raceCardTemp);
    if (raceCardTemp === undefined || raceCardTemp === '' || raceCardTemp.details === undefined) {
        store.dispatch(getRacingData(data.action.raceCardId));
        return;
    }
    let races = data.races.split(',');
    races.forEach((race: any) => {
        raceCardTemp.details[race - 1][field] = status;
    });
    LocalStorageService.setItem('mp_raceinfo', JSON.stringify(raceCardTemp));
    store.dispatch(setRaceCardChange());
    store.dispatch(setRaceCardEventChage());
};

const changeRunner = async (data: any) => {
    let raceCardTemp: any = await RacingService.getLocalRaceData();
    raceCardTemp = JSON.parse(raceCardTemp);
    if (raceCardTemp === undefined || raceCardTemp === '' || raceCardTemp.details === undefined) {
        store.dispatch(getRacingData(data.action.raceCardId));
        return;
    }
    let racecard = raceCardTemp.details;
    //let obj = { action: data.action, races: data.races, horses:any };
    if (data.action === 'withDraw') {
        const withdrawHorses = data.horses.split(',');
        let notifyMessage = `${data.venueCode} RACE ${data.races} : Horse(s) ${data.action} - ${withdrawHorses}`;
        if (data.horses.length > 0) {
            raceToast(notifyMessage, data.raceCardId);
        }
        let runners = racecard[data.races - 1]['runners'];
        const resultRunners = runners?.map((item: any) => {
            item.scratched = 'N';
            if (withdrawHorses.includes(item.position)) {
                item.scratched = 'Y';
                return item;
            }
            return item;
        });
        raceCardTemp.details[data.races - 1]['runners'] = resultRunners;
        LocalStorageService.setItem('mp_raceinfo', JSON.stringify(raceCardTemp));
        store.dispatch(setRaceCardChange());
    }
};
